import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface PropsType {
  ChartTitle: string,
  XAxislabels: string[],
  Dataset_1_Title: string,
  Dataset_2_Title: string,
  Dataset_1_Array: string[],
  Dataset_2_Array: string[],


}

export function TwoY_AxisChart({ ChartTitle, XAxislabels, Dataset_1_Array, Dataset_1_Title, Dataset_2_Array, Dataset_2_Title }: PropsType) {




  const options = {
    responsive: true,
    interaction: {
      mode: "index" as const,
      intersect: true
    },
    stacked: true,
    plugins: {
      title: {
        display: true,
        text: ChartTitle
      }
    },
    scales: {
      y: {
        type: "linear" as const,
        display: true,
        position: "left" as const,
        title: {
          display: true,
          text: Dataset_1_Title,
          font: {
            size: 14
          }
        }

      },
      y1: {
        type: "linear" as const,
        display: true,
        position: "right" as const,
        title: {
          display: true,
          text: Dataset_2_Title,
          font: {
            size: 14
          }
        },

        grid: {
          drawOnChartArea: false,
        }
      },
    }


  };

  let labels = XAxislabels;



  const data = {
    labels,
    datasets: [
      {
        label: Dataset_1_Title,
        data: Dataset_1_Array,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        yAxisID: "y",
        tension: 0.3
      },
      {
        label: Dataset_2_Title,
        data: Dataset_2_Array,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        yAxisID: "y1",
        tension: 0.3
      }
    ]
  };

  return <Line options={options} data={data} style={{ 'backgroundColor': 'white' }} />;
}


